import React, { useEffect, useState, useRef, useCallback } from 'react';
import ProgramsdGrid from './programsGrid';
import Filters from './programfilter';
import { Alert } from 'antd';
import apiCalls from 'src/api/apiCalls';

const Programs = () => {
    const [currencies, setCurrencies] = useState()
    const [error, setError] = useState(null);
    const [statusLu, setStatusLu] = useState()
    const [filterValues, setFilterValues] = useState({ "programName": null, "currency": null, state: null });
    const [isExcelExport, setIsExcelExport] = useState(false);
    const shouldLog = useRef(true);
    const refreshRef = useRef();
    useEffect(() => {
        if (shouldLog.current) {
            shouldLog.current = false;
            getCurrencyLu();
            getStatusLu()
        }
    }, [])
    const getCurrencyLu = async () => {
        const response = await apiCalls.getCurrenciesLu();
        if (response) {
            setCurrencies(response.data?.Currency)
        }
        else {
            setError(apiCalls.isErrorDispaly(response))
        }
    }
    const getStatusLu = async () => {
        const response = await apiCalls.getStatusLu();
        if (response) {
            setStatusLu(response.data?.Status)
        }
        else {
            setError(apiCalls.isErrorDispaly(response))
        }
    }
  
    const handleSearch = useCallback((values) => {
        setFilterValues({
            programName: values?.programName || null,
            currency: values?.currency || null,
            state: values?.state || null,
        });
    },[])

    const handleExcelExport = useCallback((callback) => {
        setIsExcelExport(callback);
    },[])

     const closeErrorHandler=useCallback(()=>{
            setError(null)
        },[])
    return (
        <div>
            <div className=''>
                {error &&
                    <div className='mb-4'>
                        <Alert
                            className='mb-6'
                            type="error"
                            description={error}
                            onClose={closeErrorHandler}
                            showIcon
                            closable
                        />
                    </div>
                }
                <Filters currencyLu={currencies} statusLuData={statusLu} filterValues={filterValues} handleExcelExport={handleExcelExport} filterObj={handleSearch} onloadGrid={refreshRef?.current?.loadGrid} />
                <ProgramsdGrid filterValues={filterValues} isExcelExport={isExcelExport} ref={refreshRef} />
            </div>
        </div>
    )
}
export default Programs